export function stringRange(min: number, max: number) {
  function refineFn(val?: string) {
    if (!val) return true;

    const length = val.length;
    return length >= min && length <= max;
  }
  return [
    refineFn,
    {
      message: `Must input between ${min} - ${max} characters`,
    },
  ] as const;
}
